<template>
  <van-tabbar v-if="show" v-model="active" active-color="#7e5678" :border="true" inactive-color="#979799">
    <!-- 首页 -->
    <van-tabbar-item to="/Home">
      <span>{{ $t('foorter.index') }}</span>
      <template #icon="props">
        <img :src="props.active ? '/img/footer/indexed.jpg' : '/img/footer/index.jpg'" :alt="$t('foorter.index')"
          v-show="show !== 0" />
        <img :src="props.active ? '/img/footer/indexed.jpg' : '/img/footer/index.jpg'" :alt="$t('foorter.index')"
          :class="$t('foorter.index')" style="height: 4rem" v-show="show === 0" />
      </template>
    </van-tabbar-item>
    <!-- 视频 -->
    <van-tabbar-item to="/Choose">
      <span>查询</span>
      <template #icon="props">
        <img :src="props.active ? '/img/footer/videoed.jpg' : '/img/footer/video.jpg'" :alt="$t('foorter.video')"
          v-show="show !== 1" />
        <img :src="props.active ? '/img/footer/videoed.jpg' : '/img/footer/video.jpg'" :alt="$t('foorter.video')"
          :class="$t('foorter.video')" style="height: 4rem" v-show="show === 1" />
      </template>
    </van-tabbar-item>
    <!-- 预约 -->
    <van-tabbar-item to="/Lottery?key=game1&id=10">
      <!-- <van-tabbar-item to="/Game"> -->
      <!-- <span>{{ $t('foorter.subscribe') }}</span> -->
      <div class="tou">投流</div>
      <template #icon="props">
        <img :src="props.active ? '/img/footer/subscribed.jpg' : '/img/footer/ico.png'" class="middle"
          :alt="$t('foorter.subscribe')" v-show="show !== 2" />
        <img :src="props.active ? '/img/footer/subscribed.jpg' : '/img/footer/subscribe.jpg'"
          :alt="$t('foorter.subscribe')" :class="$t('foorter.subscribe')" style="height: 4rem" v-show="show === 2" />
      </template>
    </van-tabbar-item>
    <!-- 中间 -->
    <!-- <van-tabbar-item to="/Choose">
      <span></span>
      <template #icon="props">
        <img class="tui" :src="props.active ? '/img/footer/ico.png' : '/img/footer/ico.png'" />
      </template>
    </van-tabbar-item> -->
    <!-- 视频 -->
    <van-tabbar-item to="/Video">
      <span>{{ $t('foorter.video') }}</span>
      <template #icon="props">
        <img :src="props.active ? '/img/footer/videoed.jpg' : '/img/footer/video.jpg'" :alt="$t('foorter.video')"
          v-show="show !== 3" />
        <img :src="props.active ? '/img/footer/videoed.jpg' : '/img/footer/video.jpg'" :alt="$t('foorter.video')"
          :class="$t('foorter.video')" style="height: 4rem" v-show="show === 3" />
      </template>
    </van-tabbar-item>
    <!-- 我的 -->
    <van-tabbar-item to="/Mine">
      <span>{{ $t('foorter.my') }}</span>
      <template #icon="props">
        <img :src="props.active ? '/img/footer/myed.jpg' : '/img/footer/my.jpg'" :alt="$t('foorter.my')"
          v-show="show !== 4" />
        <img :src="props.active ? '/img/footer/myed.jpg' : '/img/footer/my.jpg'" :alt="$t('foorter.my')"
          :class="$t('foorter.my')" style="height: 4rem" v-show="show === 4" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0,
    }
  },
  methods: {},
  watch: {
    $route(to) {
      if (to.name == 'home') {
        this.active = 0
        this.show = true
      } else if (to.name == 'choose') {
        this.active = 1
        this.show = true
      } else if (to.name == 'game') {
        this.active = 2
        this.show = true
      } else if (to.name == 'video') {
        this.active = 3
        this.show = true
      } else if (to.name == 'mine') {
        this.active = 4
        this.show = true
      } else {
        this.show = false
      }
    },
  },
  created() {
    if (this.$route.name == 'home') {
      this.active = 0
      this.show = true
    } else if (this.$route.name == 'choose') {
      this.active = 1
      this.show = true
    } else if (this.$route.name == 'game') {
      this.active = 2
      this.show = true
    } else if (this.$route.name == 'video') {
      this.active = 3
      this.show = true
    } else if (this.$route.name == 'mine') {
      this.active = 4
      this.show = true
    } else {
      this.show = false
    }
  },
}
</script>

<style lang="less" scoped>
@tabbar-height: 110px;
@tabbar-img: 75px;

.van-tabbar {
  height: @tabbar-height;
}

.van-tabbar-item--active,
.van-tabbar-item {
  // background-color: #000;
}

.van-tabbar-item__icon img {
  height: @tabbar-img;
}

.tou {
  height: @tabbar-height;
  display: flex;
  flex-direction: column;
  justify-content: end;
  padding: 20px;
}

.middle {
  width: 150px;
  height: 110px !important;
  position: absolute;
  top: -50px;
  left: -70px;
}

.van-tabbar-item {
  font-size: 26px;
  position: relative;
}

.tui {
  width: 4rem;
  height: 4rem !important;
  margin-top: -7.333vw;
  background-color: white;
  border-radius: 50%;
  border: 10px solid white;
  z-index: 10;
}

[class*='van-hairline']::after {
  border: none !important;
}
</style>
